import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_stbbbc5d9b: FaireCollectionEntity = {
  token: "pbc_stbbbc5d9b",
  type: "collection",
  name: "50% OFF CLEARANCE ✈️✈️SHIPS TODAY 🚚📦",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6ff2532066eb71ecc09dbd831eab3a25b6683ff0942472c8c4d6f55ae2654530.jpeg",
  itemCount: 86,
  description:
    "Priced to go and ready to SHIP TODAY! Collection items are Final Sale.\nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:30.845Z",
    importedBy: "entity-db-import-collections",
  },
};
